import { Fragment, h } from 'preact';
import Button from '../form/Button';
import Dialog from '../media/Dialog';
import { useCallback, useState } from 'preact/hooks';
import { Job } from '../../model/Job';
import JobVariationItem from '../../model/JobVariationItem';
import { IconType } from '../media/Icon';
import AllocateVariationsForm from './AllocateVariationsForm';

interface Props {
  job: Job;
  variations: JobVariationItem[];
  onSuccess?(): any;
}

export default function AllocateVariationsButton({job, variations, onSuccess}: Props) {
  const {length} = variations;
  if (length === 0)
    return null;

  const [showDialog, toggleDialog] = useState(false);

  const dialog = {
    show: toggleDialog.bind(null, true),
    hide: toggleDialog.bind(null, false)
  };

  const click = useCallback((event: MouseEvent) => {
    event.stopPropagation();
    if (!showDialog) toggleDialog(true);
  }, [toggleDialog, showDialog, job, variations]);


  return (
    <Fragment>
      <Button
        small={true}
        onClick={click}
        onlyIcon={IconType.ALLOCATE}
        tooltip={`Allocate${length > 1 ? ` ${length}`:''} Variation${length === 1 ? '':'s'}`}
      />
      <Dialog show={showDialog} onRequestClose={dialog.hide}>
        <AllocateVariationsForm
          job={job}
          variations={variations}
          onCancel={dialog.hide}
          onSuccess={() => {
            if (onSuccess) onSuccess();
            dialog.hide();
          }}
        />
      </Dialog>
    </Fragment>
  )
}